// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__30aYS","left":"StickyBox_left__7CdMI","right":"StickyBox_right__2Gm36"};